export default __webpack_public_path__ + "static/media/Pal_before_3.e96688fd.JPG";